import React from "react";
import "./index.scss";
import home from "../../../Assets/Icons/mobile-home.svg";
import users from "../../../Assets/Icons/users.svg";
import bag from "../../../Assets/Icons/bag-dark.svg";
import gear from "../../../Assets/Icons/gear.svg";
import { ReactSVG } from "react-svg";
import { Typography } from "antd";
import { Link, useLocation } from "react-router-dom";
import { activeMobileNavChecker } from "../../../Utils/helpers";

const NavMenu = ({ src, label, pathname, link }) => (
  <Link
    to={link}
    className={`mobile-nav-menu-item ${activeMobileNavChecker(
      pathname,
      label
    )}`}
  >
    <ReactSVG src={src} alt={label} />
    <Typography className="mobile-nav-menu-label">{label}</Typography>
  </Link>
);

const BottomBar = () => {
  const { pathname } = useLocation();

  return (
    <div className="mobile-bottom-bar-container">
      <NavMenu
        src={home}
        label="Dashboard"
        pathname={pathname}
        link="/dashboard/1"
      />
      <NavMenu
        src={users}
        label="Candidates"
        pathname={pathname}
        link="/dashboard/candidates/1"
      />
      <NavMenu
        src={bag}
        label="Employers"
        pathname={pathname}
        link="/dashboard/employers"
      />
      <NavMenu
        src={gear}
        label="Jobs"
        pathname={pathname}
        link="/dashboard/jobs/1"
      />
    </div>
  );
};

export default BottomBar;
